export default "__VITE_ASSET__CTgsRTCq__"